import React, { useEffect, useState } from 'react'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'

function Carousel({ Images }) {
    const slides = Array.isArray(Images) ? Images : []
    const [activeIndex, setActiveIndex] = useState(0)
    const totalSlides = slides.length

    useEffect(() => {
        if (totalSlides <= 1) return undefined

        const timer = window.setInterval(() => {
            setActiveIndex((index) => (index + 1) % totalSlides)
        }, 5000)

        return () => window.clearInterval(timer)
    }, [totalSlides])

    const goToPrevious = () => {
        setActiveIndex((index) => (index === 0 ? totalSlides - 1 : index - 1))
    }

    const goToNext = () => {
        setActiveIndex((index) => (index + 1) % totalSlides)
    }

    return (
        <div className='relative w-full overflow-hidden rounded-3xl lg:col-span-12' style={{ height: '350px' }}>
            {slides.map((img, index) => (
                <img
                    key={index}
                    src={img}
                    alt='Package Images'
                    className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${index === activeIndex ? 'opacity-100' : 'opacity-0'}`}
                />
            ))}

            {totalSlides > 1 && (
                <>
                    <button
                        type='button'
                        onClick={goToPrevious}
                        className='absolute left-3 top-1/2 z-10 -translate-y-1/2 rounded-full border border-white/40 bg-slate-900/35 p-2 text-white transition hover:bg-slate-900/55'
                        aria-label='Previous slide'
                    >
                        <FiChevronLeft />
                    </button>
                    <button
                        type='button'
                        onClick={goToNext}
                        className='absolute right-3 top-1/2 z-10 -translate-y-1/2 rounded-full border border-white/40 bg-slate-900/35 p-2 text-white transition hover:bg-slate-900/55'
                        aria-label='Next slide'
                    >
                        <FiChevronRight />
                    </button>
                </>
            )}
        </div>
    )
}

export default Carousel